import {
  DatePicker,
  Button,
  Form,
  Input,
  Select,
  Table,
  Modal,
  InputNumber,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { columnsData } from "./data";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../../components/notification";
import { api } from "../../../services/api/api.index";
import { API_URL } from "../../../services/api/config";
import {
  AiOutlineFilter,
  AiOutlineReload,
  AiOutlineSearch,
} from "react-icons/ai";
import { LuFilePlus2 } from "react-icons/lu";
import moment from "moment";
import { FiPlusCircle } from "react-icons/fi";

import { Link, useNavigate } from "react-router-dom";
import OverlaySpinner from "../../../components/overlaySpinner/OverlaySpinner";
import {
  localGetMenu,
  localGetRefreshToken,
  localSaveToken,
  localSaveRefreshToken,
  localRemoveRefreshToken,
  localRemoveToken,
  localRemoveMenu,
} from "../../../utils/localStorage";
import axios from "axios";
import { UserContext } from "../../../context/context";
import PanigationAntStyled from "../../../components/layout/PanigationAntStyled";
const { RangePicker } = DatePicker;
const ListBlog = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [openModalPosition, setOpenModalPosition] = useState(false);
  const [newPosition, setNewPosition] = useState(undefined);
  const [form] = Form.useForm();
  const [openSearch, setOpenSearch] = useState(false);
  const [recordPosition, setRecordPosition] = useState(undefined);
  let navigate = useNavigate();
  const [filter, setFilter] = useState({
    q: undefined,
    status: undefined,
    from_date: undefined,
    to_date: undefined,
    page: 1,
    limit: 10,
  });
  const onChangePaging = (page, pageSize) => {
    setFilter({
      ...filter,

      page: page,
      limit: pageSize,
    });
  };

  const getData = async () => {
    setLoading(true);

    try {
      let data = await api.get(`${API_URL}api/v1/blogs`, {
        ...filter,
        depth: 2,
      });
      let dataFake = [];

      for (let i = 0; i < data?.data?.length; i++) {
        if (data?.data[i]?.children?.length === 0) {
          dataFake.push({ ...data?.data[i], children: undefined });
        } else {
          dataFake.push({ ...data?.data[i] });
        }
      }
      setDataSource(dataFake);
      setTotal(data?.metadata?.totalItems);
      setLoading(false);
    } catch (e) {
      setLoading(false);

      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          getData();
        } catch (e) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const handleFinishForm = (e) => {
    setFilter({
      ...filter,
      page: 1,
      q: e?.q?.length > 0 ? e?.q?.trim() : undefined,
      status: e?.status,
      role: e?.role,
      branch_code: e?.branch_code,
      is_branch: e?.is_branch,
      from_date: e?.date ? moment(e.date[0]).format("YYYY-MM-DD") : undefined,
      to_date: e?.date ? moment(e.date[1]).format("YYYY-MM-DD") : undefined,
    });
  };

  const handleChangeStatus = async (e, record) => {
    setLoading(true);
    try {
      let { data } = await api.put(`${API_URL}api/v1/blogs/${record._id}`, {
        status: e ? "ACTIVE" : "INACTIVE",
      });
      setLoading(false);
      notifySuccess("Đổi trạng thái thành công!");
      getData();
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleChangeStatus(e, record);
        } catch (e) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const openChangePosition = async (record) => {
    setOpenModalPosition(true);
    setRecordPosition(record);
  };

  const handleSubmitChangePosition = async () => {
    try {
      let { data } = await api.put(
        `${API_URL}api/v1/blogs/${recordPosition._id}`,
        {
          position: newPosition,
        }
      );
      notifySuccess("Cập nhật vị trí thành công");
      setLoading(false);
      setRecordPosition(undefined);
      setNewPosition(undefined);
      setOpenModalPosition(false);
      getData();
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleSubmitChangePosition();
        } catch (e) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };
  const { state, dispatch } = useContext(UserContext);
  const handleKeyUp = (event) => {
    if (event.keyCode === 13 || event.key == "Enter") {
      form.submit();
    }
  };
  const [pageMenu, setPageMenu] = useState({
    list: false,
    details: false,
    create: false,
    update: false,
    assign: false,
    sync: false,
    import: false,
    export: false,
  });
  useEffect(() => {
    let localMenu = JSON.parse(localGetMenu());
    let fakePageMenu = { ...pageMenu };
    let fakeNewMenu = localMenu || [];
    let checkAll = fakeNewMenu.find((x) => x?.fe_route === "/forms");
    if (!checkAll) {
      navigate("/");
    } else {
      let checkView = checkAll?.permissions?.find(
        (y) => y?.permission === "VIEW_LIST"
      );
      if (checkView?.status === "INACTIVE") {
        navigate("/");
      } else {
        fakePageMenu = { ...fakePageMenu, list: true };
      }

      fakePageMenu = {
        ...fakePageMenu,
        create:
          checkAll?.permissions?.find((y) => y?.permission === "CREATE")
            ?.status === "ACTIVE"
            ? true
            : false,
        update:
          checkAll?.permissions?.find((y) => y?.permission === "UPDATE")
            ?.status === "ACTIVE"
            ? true
            : false,
        details:
          checkAll?.permissions?.find((y) => y?.permission === "VIEW_DETAIL")
            ?.status === "ACTIVE"
            ? true
            : false,
        assign:
          checkAll?.permissions?.find((y) => y?.permission === "ASSIGN")
            ?.status === "ACTIVE"
            ? true
            : false,
        sync:
          checkAll?.permissions?.find((y) => y?.permission === "SYNC")
            ?.status === "ACTIVE"
            ? true
            : false,
        import:
          checkAll?.permissions?.find((y) => y?.permission === "IMPORT")
            ?.status === "ACTIVE"
            ? true
            : false,
        export:
          checkAll?.permissions?.find((y) => y?.permission === "EXPORT")
            ?.status === "ACTIVE"
            ? true
            : false,
      };

      setPageMenu(fakePageMenu);
    }
  }, [state]);

  useEffect(() => {
    pageMenu.list && getData();
  }, [pageMenu, filter]);

  return (
    pageMenu.list && (
      <>
        <OverlaySpinner text="Vui lòng đợi ..." open={loading} />
        <div className="formCreate" onKeyDown={handleKeyUp}>
          <Modal
            title={<div>Bộ lọc</div>}
            open={openSearch}
            onCancel={(e) => {
              setOpenSearch(false);
            }}
            footer={null}
            centered
          >
            <Form layout="vertical" form={form} onFinish={handleFinishForm}>
              <div>Trạng thái</div>
              <Form.Item
                name="status"
                className="formCreate__search__select"
                style={{ width: "100%" }}
              >
                <Select
                  allowClear
                  options={[
                    { value: "ACTIVE", label: "Hoạt động" },
                    { value: "INACTIVE", label: "Dừng hoạt động" },
                  ]}
                  placeholder="Tất cả"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <div>Ngày tạo</div>
              <Form.Item
                name="date"
                className="formCreate__search__date"
                style={{ width: "100%" }}
              >
                <RangePicker style={{ width: "100%" }} />
              </Form.Item>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                <Button
                  className="formCreate__search__button"
                  onClick={() => {
                    form.submit();
                    setOpenSearch(false);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AiOutlineSearch size={14} />
                  &nbsp;Áp dụng
                </Button>
                <Button
                  className="clients__search__button"
                  onClick={() => {
                    form.resetFields();
                    setFilter({
                      ...filter,

                      status: undefined,

                      from_date: undefined,
                      to_date: undefined,

                      page: 1,
                      limit: 10,
                    });
                    setOpenSearch(false);
                  }}
                >
                  &nbsp;Bỏ bộ lọc
                </Button>
              </div>
            </Form>
          </Modal>
          <Modal
            open={openModalPosition}
            onCancel={(e) => {
              setOpenModalPosition(false);
            }}
            title="Đổi vị trí bài viết"
            footer={null}
            centered
            width={360}
          >
            <div>Vị trí cũ: {recordPosition?.position}</div>
            <div>
              Vị trí mới:{" "}
              <InputNumber
                onChange={(e) => setNewPosition(e)}
                value={newPosition}
              />
            </div>
            <div
              style={{
                marginTop: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <button
                onClick={() => handleSubmitChangePosition()}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgb(56, 114, 174)",
                  color: "#fff",
                  width: "120px",
                  borderRadius: "6px",
                  height: "32px",
                  cursor: "pointer",
                  border: "1px solid rgb(56, 114, 174)",
                }}
              >
                Đồng ý
              </button>
            </div>
          </Modal>
          <Form
            className="formCreate__search"
            layout="vertical"
            form={form}
            onFinish={handleFinishForm}
          >
            <Form.Item
              label="Tìm kiếm"
              name="q"
              className="formCreate__search__input"
              style={{
                width: pageMenu.create
                  ? "calc(100% - 868px)"
                  : "calc(100% - 638px)",
              }}
            >
              <Input placeholder="Nhập tên bài viết" />
            </Form.Item>

            <Form.Item
              label="Trạng thái"
              name="status"
              className="formCreate__search__select"
            >
              <Select
                allowClear
                options={[
                  { value: "ACTIVE", label: "Hoạt động" },
                  { value: "INACTIVE", label: "Dừng hoạt động" },
                ]}
                placeholder="Tất cả"
              />
            </Form.Item>

            <Form.Item
              label="Ngày tạo"
              name="date"
              className="formCreate__search__date"
            >
              <RangePicker />
            </Form.Item>

            <Button
              className="formCreate__search__button"
              onClick={() => form.submit()}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AiOutlineSearch size={20} />
              &nbsp;Tìm kiếm
            </Button>
            <Button
              className="clients__search__button"
              onClick={() => {
                form.resetFields();
                setFilter({
                  ...filter,
                  q: undefined,
                  status: undefined,
                  role: undefined,
                  from_date: undefined,
                  to_date: undefined,
                  branch_code: undefined,
                  is_branch: undefined,
                  page: 1,
                  limit: 10,
                });
              }}
            >
              <AiOutlineReload size={20} />
              &nbsp;Refresh
            </Button>
            {pageMenu.create && (
              <Link
                className="formCreate__search__button__new"
                to={`/blog-create`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FiPlusCircle size={20} />
                &nbsp;Tạo mới
              </Link>
            )}
          </Form>
          <Form
            className="formCreate__search--mobile"
            layout="vertical"
            form={form}
            onFinish={handleFinishForm}
          >
            <Form.Item
              label="Tìm kiếm"
              name="q"
              className="formCreate__search__input"
              style={{
                width: "calc(100% - 128px)",
              }}
            >
              <Input placeholder="Nhập tên bài viết" />
            </Form.Item>

            <Button
              className="formCreate__search__button"
              onClick={() => form.submit()}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AiOutlineSearch size={14} />
              &nbsp;Tìm kiếm
            </Button>
          </Form>
          <div
            className="formCreate__search--mobile"
            style={{
              width: "100%",

              justifyContent: "right",
              marginBottom: "8px",
              marginTop: "-12px",
            }}
          >
            <Button
              className="clients__search__button"
              style={{ marginRight: "8px" }}
              onClick={() => {
                setOpenSearch(true);
              }}
            >
              <AiOutlineFilter size={14} />
              &nbsp;Bộ lọc
            </Button>
            {pageMenu.create && (
              <Link
                className="formCreate__search__button__new"
                to={`/blog-create`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  textDecoration: "none",
                }}
              >
                <FiPlusCircle size={14} />
                &nbsp;Tạo mới
              </Link>
            )}
          </div>
          <Table
            bordered
            className="newpadding"
            rowKey="_id"
            scroll={{ x: 1200 }}
            columns={columnsData(
              { handleChangeStatus, openChangePosition, navigate },
              pageMenu
            )}
            dataSource={dataSource}
            pagination={false}
          />
          <PanigationAntStyled
            style={{ padding: "0 0 24px 0" }}
            current={filter.page}
            pageSize={filter.limit}
            showSizeChanger
            onChange={onChangePaging}
            showTotal={() => `Tổng ${total}`}
            total={total}
          />{" "}
          <div className="gapMobile"></div>
        </div>
      </>
    )
  );
};

export default ListBlog;
